'use client';

import { createContext, useContext, type ReactNode } from 'react';
import type { PropertyDetailListing } from '../types';
import type { ApartmentReviews, BuildingReviewsSnapshot } from '@/src/lib/api/endpoints/apartmentReviews';
import { isApartmentReviewsEligible } from '@/src/lib/api/endpoints/apartmentReviews';
import { useApartmentReviews } from '@/src/lib/hooks/query/useApartmentReviews';
import { useFeatureFlag } from '@/src/lib/feature-flags';

const ReviewsContext = createContext<{ lotId: string; reviews: ApartmentReviews | null; mockEnabled: boolean }>({
  lotId: '',
  reviews: null,
  mockEnabled: false,
});

export function ApartmentReviewsProvider({
  listing,
  pdpType,
  snapshot,
  children,
}: {
  listing: PropertyDetailListing;
  pdpType: 'unit' | 'building';
  snapshot?: BuildingReviewsSnapshot;
  children: ReactNode;
}) {
  const reviews = useApartmentReviews(listing, pdpType, snapshot);
  const previewEnabled = useFeatureFlag('apartmentReviewsPreview');
  const mockEnabled = previewEnabled && isApartmentReviewsEligible(listing);
  return (
    <ReviewsContext.Provider value={{ lotId: listing.maloneLotIdEncoded ?? '', reviews, mockEnabled }}>
      {children}
    </ReviewsContext.Provider>
  );
}

export const useApartmentReviewsContext = () => useContext(ReviewsContext);
